export enum GoJsModelProperties {
  HasDarkMode = 'HasDarkMode',
  NodeHover = 'NodeHover',
}
